import { ReactElement } from 'react';

import { useFallbackTranslation } from '../../../utils/hooks';

import styles from '../Basket.module.css';

const Empty = (): ReactElement | null => {
  const { t } = useFallbackTranslation();
  return (
    <div className={styles.emptyMessage}>
      <span>{t('cart.YourCartEmpty')}</span>
    </div>
  );
};

export default Empty;
